"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupConcat = void 0;
const Helpers_1 = require("../functions/Helpers");
const BaseAggregator_1 = require("./BaseAggregator");
class GroupConcat extends BaseAggregator_1.BaseAggregator {
    static emptyValue() {
        return (0, Helpers_1.string)('').toRDF();
    }
    init(start) {
        return start.value;
    }
    put(state, term) {
        return state + this.separator + term.value;
    }
    result(state) {
        return (0, Helpers_1.string)(state).toRDF();
    }
}
exports.GroupConcat = GroupConcat;
//# sourceMappingURL=GroupConcat.js.map